import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { fetchBlogPosts } from '../../contentful';
import { Helmet } from "react-helmet";

function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);

  useEffect(() => {
    const getPost = async () => {
      const posts = await fetchBlogPosts();
      const foundPost = posts.find((p) => p.fields.slug === slug);
      setPost(foundPost);
    };
    getPost();
  }, [slug]);

  if (!post) return <p>Loading...</p>;

  return (
    <div className="blog-post-detail">

        <Helmet>
        <title>{post.fields.title} | Wholistic Nursing Care Blog</title>
        <meta name="description" content={post.fields.body.content[0].content[0].value.substring(0, 150)} />
        <link rel="canonical" href={`https://wholistic.netlify.app/blog/${post.fields.slug}`} />
      </Helmet>
      <img src={post.fields.featuredImage.fields.file.url} alt={post.fields.title} className="blog-post-image" />

      <div className="blog-post-content">
        <h1>{post.fields.title}</h1>

        {/* Display Author and Publish Date */}
        <p className="blog-meta">
          By {post.fields.author || "Unknown Author"} | {new Date(post.fields.publishDate).toLocaleDateString()}
        </p>

        {/* Displaying Rich Text Content */}
        {post.fields.body.content.map((section, idx) => (
          section.content && section.content[0] ? (
            <p key={idx}>{section.content[0].value}</p>
          ) : (
            <p key={idx}></p>  // If content[0] doesn't exist, render an empty paragraph or handle as needed
          )
          ))}

      </div>
    </div>
  );
}

export default BlogPost;
